import React from "react";
import { ElectricGraph } from "./ElectricGraph";

export function DashBoard() {

    return (
        <>
            <ElectricGraph />
        </>
    );
}

